import { Check, Copy, Loader2, Store } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";

import { statusPagamento } from "./api";

const dinheiro = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;
const INTERVALO_MS = 4000;

// O PIX gerado: QR e copia-e-cola. Consulta o status de 4 em 4 s; aprovado,
// chama `onPago`. Se o cliente fechar o navegador, o pagamento entra mesmo
// assim pelo aviso do Mercado Pago — o comprovante fica no link dele.
export function PixGerado({ token, quem, pagamento, cobranca, onPago, darkMode }) {
  const [copiado, setCopiado] = useState(false);
  const timer = useRef(null);
  const onPagoRef = useRef(onPago);
  onPagoRef.current = onPago;
  const jaPagou = useRef(false);
  const cartao = darkMode ? "bg-zinc-900 border-zinc-800" : "bg-zinc-50 border-zinc-200";

  useEffect(() => {
    if (!pagamento?.id) return undefined;
    timer.current = setInterval(async () => {
      const r = await statusPagamento(token, pagamento.id, quem);
      // Duas consultas em voo podem voltar "aprovado": o comprovante abre uma vez
      if (r.ok && r.dados?.aprovado && !jaPagou.current) {
        jaPagou.current = true;
        clearInterval(timer.current);
        onPagoRef.current?.();
      }
    }, INTERVALO_MS);
    return () => clearInterval(timer.current);
  }, [token, quem, pagamento]);

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(cobranca?.qr_code || "");
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2500);
    } catch {
      toast.error("Copie o código manualmente.");
    }
  };

  return (
    <div className="flex flex-col items-center text-center" data-e2e="pix-gerado">
      <p className="text-sm opacity-70">Pague no app do seu banco</p>
      <p className="text-3xl font-black mt-1 tabular-nums">{dinheiro(pagamento?.valor_pix)}</p>
      {pagamento?.cashback_usado > 0 ? (
        <p className="text-xs text-emerald-500 font-semibold mt-1">+ {dinheiro(pagamento.cashback_usado)} da sua carteira de cashback</p>
      ) : null}
      {cobranca?.qr_code_base64 ? (
        <img src={`data:image/png;base64,${cobranca.qr_code_base64}`} alt="QR Code do PIX"
          className="w-56 h-56 mt-4 rounded-xl bg-white p-2" />
      ) : null}
      <button type="button" onClick={copiar} data-e2e="pix-copiar"
        className={`mt-4 w-full rounded-2xl border px-4 py-3 flex items-center gap-2 text-left ${cartao}`}>
        <span className="flex-1 min-w-0 truncate font-mono text-xs opacity-70">{cobranca?.qr_code}</span>
        {copiado ? <Check className="w-4 h-4 text-emerald-500" /> : <Copy className="w-4 h-4" />}
      </button>
      <p className="mt-5 flex items-center gap-2 text-sm opacity-70">
        <Loader2 className="w-4 h-4 animate-spin" /> Aguardando o pagamento...
      </p>
    </div>
  );
}

export function PagueNoCaixa({ mesa, eu, forma, darkMode }) {
  const nomeForma = forma === "cartao" ? "cartão" : forma === "pix" ? "PIX" : "dinheiro";
  const cartao = darkMode ? "bg-zinc-900 border-zinc-800" : "bg-zinc-50 border-zinc-200";
  return (
    <div className="flex flex-col items-center text-center" data-e2e="pague-no-caixa">
      <span className="w-16 h-16 rounded-full bg-primary/10 text-primary flex items-center justify-center mb-4">
        <Store className="w-8 h-8" />
      </span>
      <h3 className="text-2xl font-black leading-tight">Pague no caixa</h3>
      <p className="text-sm opacity-70 mt-2 max-w-xs">
        O pagamento em {nomeForma} é feito no caixa. Vá até lá e diga:
      </p>
      <div className={`mt-4 w-full rounded-2xl border px-4 py-3 ${cartao}`}>
        <p className="text-xs uppercase tracking-widest opacity-60">{mesa?.nome || `Mesa ${mesa?.numero ?? ""}`}</p>
        <p className="text-xl font-black">{eu?.nome || "Cliente"}</p>
      </div>
      <p className="text-xs opacity-60 mt-3 max-w-xs">O caixa recebe e já libera a sua saída.</p>
    </div>
  );
}
